import { AppShell, Container, Group } from '@mantine/core';
import { Header } from '../Header';
import { pb } from '../../lib/pocketbase';
import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { RecordModel } from 'pocketbase';
import { VersionInfo } from '../VersionInfo';

interface UserModel {
  id: string;
  email: string;
  name?: string;
  avatar?: string;
  verified: boolean;
  admin: boolean;
  created: string;
  updated: string;
}

interface SettingsConfig {
  title: string;
  primaryColor: string;
}

interface SettingsRecord extends RecordModel {
  config: SettingsConfig;
  logo?: string;
  favicon?: string;
}

export function Layout() {
  const [settings, setSettings] = useState<SettingsRecord | null>(null);
  const [isLoadingSettings, setIsLoadingSettings] = useState(true);
  const user = pb.authStore.model as unknown as UserModel;

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        // Try to get existing settings
        const records = await pb.collection('settings').getList(1, 1);
        
        if (records.items.length > 0) {
          const record = records.items[0] as SettingsRecord;
          console.log('Layout fetched settings:', record);
          setSettings(record);
        } else {
          // Create default settings if none exist
          const defaultSettings = {
            config: {
              title: 'ASGS 2.1',
              primaryColor: 'red'
            }
          };
          const newRecord = await pb.collection('settings').create(defaultSettings);
          console.log('Created default settings:', newRecord);
          setSettings(newRecord as SettingsRecord);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      } finally {
        setIsLoadingSettings(false);
      }
    };

    fetchSettings();
  }, []);

  const handleLogout = () => {
    pb.authStore.clear();
  };

  // If no user, don't render anything
  if (!user) {
    return null;
  }

  if (isLoadingSettings) {
    return (
      <div style={{ 
        position: 'fixed', 
        top: 0, 
        left: 0, 
        right: 0, 
        bottom: 0, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#f8f9fa'
      }}>
        Loading...
      </div>
    );
  }

  const getLogoUrl = () => {
    if (!settings?.id || !settings?.logo) return undefined;
    return pb.files.getURL(settings, settings.logo);
  };

  return (
    <AppShell
      header={{ height: 140 }}
      padding="md"
      footer={{ height: 40 }}
    >
      <AppShell.Header bg="white" style={{ padding: '10px 0' }}>
        <Header 
          user={user} 
          onLogout={handleLogout} 
          appTitle={settings?.config.title || 'ASGS 2.1'}
          logoUrl={getLogoUrl()}
        />
      </AppShell.Header>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>

      <AppShell.Footer bg="gray.2">
        <Container size="xl" h="100%">
          <Group justify="flex-end" h="100%">
            <VersionInfo />
          </Group>
        </Container>
      </AppShell.Footer>
    </AppShell>
  );
}
